import { userSessionStore } from '@/lib/auth/user-session-store.js';

import { readCsrfCookie } from './cookies.js';
import { createAuthClient } from './create-auth-client.js';

export const userClient = createAuthClient(userSessionStore, {
  refreshPath: '/auth/refresh',
  logoutPath: '/auth/logout',
  readCsrfCookie,
});

export const userApiFetch = userClient.apiFetch;
